<template>
  <div v-show="loading">
    <div class="fullview">
      <div class="loading-spacer"></div>
      <vue-loading type="bars" color="#7E6990" :size="{ width: '150px', height: '150px' }"></vue-loading>
      <div class="message">{{message}}</div>
    </div>
  </div>
</template>

<script>
import { VueLoading } from "vue-loading-template";
export default {
  name: "loading",
  props: ["message"],
  components: {
    VueLoading
  }
};
</script>

<style>
.fullview {
  width: 100%;
  height: 100%;
  background: #efedf1;
  position: fixed;
  top: 0;
  left: 0;
}
.loading-spacer {
  height: 30%;
}
.message {
  margin: 10px;
  font-size: 25px;
  color: grey;
  text-align: center;
}
</style>